import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { StaticAssetUrlPipe } from '@rma/generic/util/environment';
import { FindMyAgentBadges } from '../../domain/results';

@Component({
  selector: 'rma-result-badges',
  imports: [TranslocoModule, StaticAssetUrlPipe],
  templateUrl: './badges.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgesComponent implements OnChanges {
  @Input()
  badges!: FindMyAgentBadges;

  @Input()
  isPaying!: boolean;

  showBadges = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['badges'] || changes['isPaying']) {
      this.showBadges = this.isPaying && (this.badges.isAwardWinner || this.badges.isHighlyRecommended || this.badges.isTrustedAgent);
    }
  }
}
